export default __webpack_public_path__ + "static/media/service-0.f331bbfa.png";